<label>{{ label }}</label>
<ul>
    <li 
        *ngFor="let option of options" 
        (click)="handleSelect(option)" 
        [ngClass]="{'selected':isSelected(option)}">
        {{ option[nameField] }}
    </li>
</ul>